function ProgressiveMenu( args ) {
	var that = this;

	args = args || {};
	args.alignWith = args.alignWith || 'top';
	args.debug = args.debug || false;
	args.menuListSel = args.menuItemSel || '.menu-list-level-1';
	args.menuItemsSel = args.menuItemSel || '.menu-item-level-1';
	args.neverInMainClass = args.menuItemSel || 'never-in-main';
	this.args = args;

	this.init = function() {
		// that.header = document.querySelector( args.headerSel );
		that.mainMenu = document.querySelector( that.args.mainMenuSel );
		that.moreContainer = document.querySelector( that.args.moreContainerSel );
		that.moreMenu = document.querySelector( that.args.moreMenuSel );
		that.moreButton = document.querySelector( that.args.moreButtonSel );

		that.mainMenuList = that.mainMenu.querySelector( that.args.menuListSel );
		that.mainMenuItems = that.mainMenu.querySelectorAll( that.args.menuItemsSel );
		that.moreMenuItems = that.moreMenu.querySelectorAll( that.args.menuItemsSel );

		// itemCompPoint (dans update) n'aura la bonne valeur que si le <ul> du menu est en position PAS static.

		if( 'static' == getComputedStyle( that.mainMenuList ).position ) {
			that.mainMenuList.style.position = 'relative';
		}
	}

	this.setMobile = function() {
		that.moreContainer.classList.remove( 'hidden' );

		that.moreMenuItems.forEach( function( thisItem, index ) {
			thisItem.classList.remove( 'hidden' );
		} );

		that.mainMenuItems.forEach( function( thisItem, index ) {
			thisItem.classList.add( 'hidden' );
		} );
	};

	this.setDesktop = function() {
		that.moreContainer.classList.add( 'hidden' );

		that.moreMenuItems.forEach( function( thisItem, index ) {
			thisItem.classList.add( 'hidden' );
		} );

		that.mainMenuItems.forEach( function( thisItem, index ) {
			thisItem.classList.remove( 'hidden' );
		} );
	}

	this.tmpHide = function() {
		that.mainMenuItems.forEach( function( thisItem, index ) {
			thisItem.classList.add( 'tmp-hidden' );
		} );
	}

	this.update = function() {
		var optionsDisplayed = 0;
		var listCompPoint;
		var itemCompPoint;
		var itemCpuStyle;
		var listCpuStyle;
		var firstItemWidth;
		var availableWidth;

		if( that.args.debug ) console.log( "Updating progressive menu. Main menu is:");
		if( that.args.debug ) console.log( that.mainMenu );

		if( that.mainMenuItems.length > 0 ) {
			switch( that.args.alignWith ) {
				case 'top':
					listCompPoint = 0;
					break;
				case 'center':
					listCompPoint = that.mainMenuList.offsetHeight / 2;
					break;
				case 'bottom':
					listCompPoint = that.mainMenuList.offsetHeight;
					break;
			}

			// On commence sur de bonnes bases. On se met en mode mobile. tmp-hidden met visibility: hidden.
			that.setMobile();
			that.tmpHide();

			availableWidth = parseFloat( getComputedStyle( that.mainMenu ).width );

			// On met temporairement une hauteur/largeur fixe au menu pour pas que la demi-seconde où ça dépasse paraisse.
			that.mainMenu.style.height = that.mainMenu.clientHeight + 'px';
			that.mainMenu.style.width = that.mainMenu.clientWidth + 'px';

			// Vérifions si on a de la place à mettre au moins 1 item
			that.mainMenuItems[0].style.whiteSpace = 'nowrap';
			that.mainMenuItems[0].classList.remove( 'hidden' );
			itemCpuStyle = getComputedStyle( that.mainMenuItems[0] );
			firstItemWidth = that.mainMenuItems[0].offsetWidth + parseFloat( itemCpuStyle.marginLeft ) + parseFloat( itemCpuStyle.marginRight );
			that.mainMenuItems[0].classList.add( 'hidden' );
			that.mainMenuItems[0].removeAttribute( 'style' );

			if( that.args.debug ) console.log( 'firstItemWidth (' + firstItemWidth + ') ?> availableWidth (' + availableWidth + ')' );

			if( firstItemWidth < availableWidth ) {
				// On passe sur chaque option pour l'afficher. On continue jusqu'à ce que ça dépasse.

				if( that.args.debug ) console.log( "There is enough space for at least one element. Looping elements..." );

				for( var index = 0; index < that.mainMenuItems.length; ++ index ) {
					itemCpuStyle = getComputedStyle( that.mainMenuItems[index] );

					that.mainMenuItems[index].classList.remove( 'hidden' );
					switch( that.args.alignWith ) {
						case 'top':
							itemCompPoint = that.mainMenuItems[index].offsetTop;
							break;
						case 'center':
							itemCompPoint = that.mainMenuItems[index].offsetTop + ( ( that.mainMenuItems[index].offsetHeight + parseFloat( itemCpuStyle.marginTop ) + parseFloat( itemCpuStyle.marginBottom ) ) / 2 );
							break;
						case 'bottom':
							itemCompPoint = that.mainMenuItems[index].offsetTop + ( that.mainMenuItems[index].offsetHeight + parseFloat( itemCpuStyle.marginTop ) + parseFloat( itemCpuStyle.marginBottom ) );
							break;
					}

					if( that.args.debug ) console.log( 'itemCompPoint (' + itemCompPoint + ') ?= listCompPoint (' + listCompPoint + ')' );

					if( that.mainMenuItems[index].classList.contains( that.args.neverInMainClass ) ) {
						if( that.args.debug ) console.log("Menu marked as overflown because element has special class \"" + that.args.neverInMainClass + "\" Re-hiding element:" );
						if( that.args.debug ) console.log( that.mainMenuItems[index] );

						that.mainMenuItems[index].classList.add( 'hidden' );
						break;
					} else if( itemCompPoint != listCompPoint ) {
						// Oups ! On vient de dépasser. On recache tout de suite celui qu'on vient d'afficher.
						if( that.args.debug ) console.log("Menu overflown. Re-hiding element:");
						if( that.args.debug ) console.log( that.mainMenuItems[index] );

						that.mainMenuItems[index].classList.add( 'hidden' );
						break;
					} else {
						// On dépasse pas encore. Tout est OK. On continue à afficher des options.
						if( that.args.debug ) console.log("Menu still not overflown with this element:");
						if( that.args.debug ) console.log( that.mainMenuItems[index] );

						++ optionsDisplayed;
					}
				}
			}


			// On vient d'afficher tout le menu bureau ! Le menu mobile devient inutile.
			if( optionsDisplayed == that.moreMenuItems.length ) {
				that.moreContainer.classList.add( 'hidden' );
			}

			// On cache autant d'options que ce qu'on vient d'afficher dans le menu mobile.
			for( var index = 0; index < optionsDisplayed; ++ index ) {
				that.moreMenuItems[index].classList.add( 'hidden' )
			}

			// On enlève visibility: hidden
			that.mainMenuItems.forEach( function( thisItem, index ) {
				thisItem.classList.remove( 'tmp-hidden' );
			} );

			// Retour à la largeur/hauteur normale
			that.mainMenu.removeAttribute('style');
		} else {
			if( that.args.debug ) console.log("Update aborted: main menu has 0 items.");
		}
	}

	this.toggle = function( button, action ) {
		var menu = that.moreMenu;
		var finalAction;

		action = action || 'toggle';

		if( 'toggle' == action ) {
			if( menu.classList.contains( 'open' ) ) {
				finalAction = 'close';
			} else {
				finalAction = 'open';
			}
		} else {
			finalAction = action;
		}

		if( ! button.classList.contains('animating') ) {
			button.classList.add('animating');
			menu.classList.add('animating');

			switch( finalAction ) {
				case 'open':
					menu.classList.add('open');
					button.classList.add('open');
				break;

				case 'close':
					menu.classList.remove('open');
					button.classList.remove('open');
				break;
			}

			function removeAnimatingClass() {
				button.classList.remove('animating');
				menu.classList.remove('animating');
				button.removeEventListener( 'transitionend', removeAnimatingClass, false );
			}

			button.addEventListener( 'transitionend', removeAnimatingClass, false );
		}
	}

	this.init();
	this.update();

	// Évènements

	this.moreButton.addEventListener( 'click', function( event ) {
		event.preventDefault();
		that.toggle( this );
	} );
}

export default ProgressiveMenu;